/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import * as React from 'react';
import { GlobalStateContext } from 'src/core/utils/contexts/GlobalStateContext';

/**
 * A hook to access the state management functions provided
 * by the state management context.
 */
export const useGlobalState = () => React.useContext(GlobalStateContext);
